import PropTypes from 'prop-types';
import useSWR from 'swr';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LazyLoad from 'react-lazyload';

import ImageCard from './ImageCard';
import { getTranslation } from '../utils/translate';
import Loader from './Loader';

const RecipeGrid = ({ payload, language }) => {
  const { data, isLoading } = useSWR(payload);

  return (
    <Grid container spacing={2}>
      {isLoading && (
        <Grid item xs={12}>
          <Loader />
        </Grid>
      )}
      {data?.data?.map((recipe) => (
        <Grid
          key={recipe.id}
          item
          xs={12}
          sm={4}
          md={4}
          lg={3}
          xl={2}
        >
          <Box
            sx={{
              height: '100%',
            }}
          >
            <LazyLoad height='100%'>
              <ImageCard
                description={getTranslation(recipe, { key: 'languages_code', code: language.code }, 'layout_translations').summary}
                url={`/recipes/${recipe.id}`}
                item={{
                  title: getTranslation(recipe, { key: 'languages_code', code: language.code }, 'layout_translations').name,
                  description: getTranslation(recipe, { key: 'languages_code', code: language.code }, 'layout_translations').summary,
                  url: `${process.env.REACT_APP_API_URL}/assets/${recipe?.imagegallery[0]?.directus_files_id}` || ''
                }}
                footerAction={<Box sx={{ my: 0.5 }} />}
              />
            </LazyLoad>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

RecipeGrid.propTypes = {
  payload: PropTypes.object.isRequired,
  language: PropTypes.shape({ code: PropTypes.string.isRequired }).isRequired,
};

export default RecipeGrid;


